import { forwardRefWithAs, PropsWithAs } from '../as';
import { Text, TextProps } from '../Text/Text';

/**
 * @beta
 */
export type LabelProps = Omit<
  TextProps,
  'lineHeight' | 'fontSize' | 'color' | 'fontWeight'
>;

/**
 * @beta
 */
export const Label = forwardRefWithAs<LabelProps, 'span'>(function Label(
  props: PropsWithAs<LabelProps, 'span'>,
  ref: React.Ref<HTMLSpanElement>
) {
  return (
    <Text
      {...props}
      color="labelColor"
      fontSize="textBase"
      lineHeight="labelLineHeight"
      fontWeight="labelFontWeight"
      ref={ref}
    />
  );
});
